import { apiCall } from './gqlClient';
const GETSUBSERVICES_QUERY = "\n  query getSubServices($serviceId: Int!) {\n    getSubServices(serviceId: $serviceId)\n    {\n      id\n\t\t\tserviceId\n\t\t\tname\n\t\t\tdescription\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tduration\n\t\t\tcapacity\n\t\t\tprice\n\t\t\torderIndex\n\t\t\tactive\n\t\t\tpublished\n\t\t\tresources\n\t\t\tproviderId\n\t\t\tisDateAlwaysAvailable\n\t\t\tisTimeAlwaysAvailable\n\t\t\treservationsCounter\n\t\t\tlocationType\n\t\t\tdefaultTimeSlotStep\n\t\t\tcustomerId\n\t\t\tmaterialResource\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getSubServicesApiCall = async function (_ref) {
  let {
    serviceId
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETSUBSERVICES_QUERY,
    variables: {
      serviceId
    },
    fragments
  });
};
const GETPUBLICSUBSERVICES_QUERY = "\n  query getPublicSubServices($serviceId: Int!, $deal: Boolean) {\n    getPublicSubServices(serviceId: $serviceId, deal: $deal)\n    {\n      id\n\t\t\tserviceId\n\t\t\tname\n\t\t\tdescription\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tduration\n\t\t\tcapacity\n\t\t\tprice\n\t\t\torderIndex\n\t\t\tactive\n\t\t\tpublished\n\t\t\tresources\n\t\t\tproviderId\n\t\t\tisDateAlwaysAvailable\n\t\t\tisTimeAlwaysAvailable\n\t\t\treservationsCounter\n\t\t\tlocationType\n\t\t\tdefaultTimeSlotStep\n\t\t\tcustomerId\n\t\t\tmaterialResource\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getPublicSubServicesApiCall = async function (_ref2) {
  let {
    serviceId,
    deal
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETPUBLICSUBSERVICES_QUERY,
    variables: {
      serviceId,
      deal
    },
    fragments
  });
};
const GETSUBSERVICESFORBOOKING_QUERY = "\n  query getSubservicesForBooking($providerId: Int) {\n    getSubservicesForBooking(providerId: $providerId)\n    {\n      id\n\t\t\tname\n\t\t\tserviceType\n\t\t\tisAlwaysAvailable\n      ...fragments\n    }\n  }";
export const getSubservicesForBookingApiCall = async function (_ref3) {
  let {
    providerId
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETSUBSERVICESFORBOOKING_QUERY,
    variables: {
      providerId
    },
    fragments
  });
};
const GETALLSUBSERVICES_QUERY = "\n  query getAllSubservices($serviceId: Int!) {\n    getAllSubservices(serviceId: $serviceId)\n    {\n      id\n\t\t\tserviceId\n\t\t\tname\n\t\t\tdescription\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tduration\n\t\t\tcapacity\n\t\t\tprice\n\t\t\torderIndex\n\t\t\tactive\n\t\t\tpublished\n\t\t\tresources\n\t\t\tproviderId\n\t\t\tisDateAlwaysAvailable\n\t\t\tisTimeAlwaysAvailable\n\t\t\treservationsCounter\n\t\t\tlocationType\n\t\t\tdefaultTimeSlotStep\n\t\t\tcustomerId\n\t\t\tmaterialResource\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getAllSubservicesApiCall = async function (_ref4) {
  let {
    serviceId
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETALLSUBSERVICES_QUERY,
    variables: {
      serviceId
    },
    fragments
  });
};
const GETALLEVENARCHIVEDSUBSERVICES_QUERY = "\n  query getAllEvenArchivedSubservices($serviceId: Int!) {\n    getAllEvenArchivedSubservices(serviceId: $serviceId)\n    {\n      id\n\t\t\tserviceId\n\t\t\tname\n\t\t\tdescription\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tduration\n\t\t\tcapacity\n\t\t\tprice\n\t\t\torderIndex\n\t\t\tactive\n\t\t\tpublished\n\t\t\tresources\n\t\t\tproviderId\n\t\t\tisDateAlwaysAvailable\n\t\t\tisTimeAlwaysAvailable\n\t\t\treservationsCounter\n\t\t\tlocationType\n\t\t\tdefaultTimeSlotStep\n\t\t\tcustomerId\n\t\t\tmaterialResource\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getAllEvenArchivedSubservicesApiCall = async function (_ref5) {
  let {
    serviceId
  } = _ref5;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETALLEVENARCHIVEDSUBSERVICES_QUERY,
    variables: {
      serviceId
    },
    fragments
  });
};
const GETPROVIDERALLSUBSERVICES_QUERY = "\n  query getProviderAllSubservices($serviceId: Int!) {\n    getProviderAllSubservices(serviceId: $serviceId)\n    {\n      id\n\t\t\tserviceId\n\t\t\tname\n\t\t\tdescription\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tduration\n\t\t\tcapacity\n\t\t\tprice\n\t\t\torderIndex\n\t\t\tactive\n\t\t\tpublished\n\t\t\tresources\n\t\t\tproviderId\n\t\t\tisDateAlwaysAvailable\n\t\t\tisTimeAlwaysAvailable\n\t\t\treservationsCounter\n\t\t\tlocationType\n\t\t\tdefaultTimeSlotStep\n\t\t\tcustomerId\n\t\t\tmaterialResource\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getProviderAllSubservicesApiCall = async function (_ref6) {
  let {
    serviceId
  } = _ref6;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETPROVIDERALLSUBSERVICES_QUERY,
    variables: {
      serviceId
    },
    fragments
  });
};
const SAVESUBSERVICE_QUERY = "\n  mutation saveSubService($request: SubServiceCreateInput!) {\n    saveSubService(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const saveSubServiceApiCall = async function (_ref7) {
  let {
    request
  } = _ref7;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SAVESUBSERVICE_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const REORDERSUBSERVICES_QUERY = "\n  mutation reorderSubServices($oldPosition: Int!, $newPosition: Int!) {\n    reorderSubServices(oldPosition: $oldPosition, newPosition: $newPosition)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const reorderSubServicesApiCall = async function (_ref8) {
  let {
    oldPosition,
    newPosition
  } = _ref8;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: REORDERSUBSERVICES_QUERY,
    variables: {
      oldPosition,
      newPosition
    },
    fragments
  });
};
const TOGGLESUBSERVICESTATUS_QUERY = "\n  mutation toggleSubServiceStatus($id: Int!, $isActive: Boolean!, $serviceId: Int!) {\n    toggleSubServiceStatus(id: $id, isActive: $isActive, serviceId: $serviceId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const toggleSubServiceStatusApiCall = async function (_ref9) {
  let {
    id,
    isActive,
    serviceId
  } = _ref9;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: TOGGLESUBSERVICESTATUS_QUERY,
    variables: {
      id,
      isActive,
      serviceId
    },
    fragments
  });
};
const DELETESUBSERVICE_QUERY = "\n  mutation deleteSubService($id: Int!) {\n    deleteSubService(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const deleteSubServiceApiCall = async function (_ref10) {
  let {
    id
  } = _ref10;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DELETESUBSERVICE_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const RESTORESUBSERVICE_QUERY = "\n  mutation restoreSubservice($id: Int!) {\n    restoreSubservice(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const restoreSubserviceApiCall = async function (_ref11) {
  let {
    id
  } = _ref11;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: RESTORESUBSERVICE_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const SAVESERVICEWITHSUBSERVICE_QUERY = "\n  mutation saveServiceWithSubService($request: ServicePlusSubServiceCreateInput!) {\n    saveServiceWithSubService(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const saveServiceWithSubServiceApiCall = async function (_ref12) {
  let {
    request
  } = _ref12;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SAVESERVICEWITHSUBSERVICE_QUERY,
    variables: {
      request
    },
    fragments
  });
};